import { types, actions } from './requests'
export const FILTERS_TYPES = {
    ...types('FILTERS'),
}
export const FILTERS_ACTIONS = {
    ...actions('FILTERS'),
}